import { CustomBackdrop, useApi, useEffect, useParams, useState } from "../../utils/globalImports";
import ProjectSummaryComponent from "./ProjectSummaryComponent";
interface ProjectSummaryProps {

}
const ProjectSummary: React.FC<ProjectSummaryProps> = ({ }) => {
  const {projectId} = useParams();
  const [Data, SetData] = useState<{ description: string, value: number, icon: string, sectionId: number, textvalue: string | null }[]>();
  const { execute, loading } = useApi();
  const fetchData = async () => {
    try {
      const { data } = await execute<any>("get", "/project/commercials", { type: 1, id: projectId, feestageId: null });
      SetData(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div>
      <ProjectSummaryComponent data={Data || []} heading="Commercials" subHeading="Overview of fee stage commercials and values." />
    <CustomBackdrop open={loading} /> 
    </div>
  );
};

export default ProjectSummary;